// @flow

// Libs
import _filter from 'lodash/filter'
import _size from 'lodash/size'

// Constants
import {
  PROP_ASSET,
  PROP_SHAPE_DATA,
} from 'fc-model-fieldborder'

export default function validateModel (model: Object): Array<{ [string]: string }> {
  const errors = []
  if (model) {
    if (!`${model[PROP_ASSET]}`.trim()) {
      errors.push({ [PROP_ASSET]: 'Asset Required' })
    }

    if (model[PROP_SHAPE_DATA].length > 3) {
      errors.push({ [PROP_SHAPE_DATA]:
        'extraFiles' })
    } else {
      const shp = _filter(model[PROP_SHAPE_DATA], (fileData: Object): boolean => {
        return fileData.name.indexOf('.shp') > -1
      })

      const dbf = _filter(model[PROP_SHAPE_DATA], (fileData: Object): boolean => {
        return fileData.name.indexOf('.dbf') > -1
      })

      const shx = _filter(model[PROP_SHAPE_DATA], (fileData: Object): boolean => {
        return fileData.name.indexOf('.shx') > -1
      })

      if (_size(shp) === 0) {
        errors.push({ [PROP_SHAPE_DATA]: 'missingShp' })
      }

      if (_size(dbf) === 0) {
        errors.push({ [PROP_SHAPE_DATA]: 'missingDbf' })
      }

      if (_size(shx) === 0) {
        errors.push({ [PROP_SHAPE_DATA]: 'missingShx' })
      }
    }
  }
  return errors
}
